import { render, staticRenderFns } from "./PaoLinkManagement.vue?vue&type=template&id=0be4a9d4&scoped=true"
import script from "./PaoLinkManagement.vue?vue&type=script&lang=js"
export * from "./PaoLinkManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4a9d4",
  null
  
)

export default component.exports